import { Component, OnInit, inject } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { CardModule } from 'primeng/card';
import { EventEmitter } from 'stream';
import { ImagesService } from './services/images.service';

@Component({
  selector: 'app-images',
  standalone: true,
  imports: [RouterOutlet, RouterModule, CardModule],
  templateUrl: './images.component.html',
  styleUrl: './images.component.css'
})
export class ImagesComponent implements OnInit {
  private imagesService = inject(ImagesService)

  ngOnInit(): void {
    this.imagesService.title.update((value) => 'Imagenes')
  }
  event(event?: EventEmitter<any>) {
    // console.log('Image Event: ', event);
  }
}
